var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitgert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4390_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8065 17.3855C19.9217 17.3183 20.6609 16.4159 20.6609 16.4159V14.5919L19.7969 13.4399L18.0017 12.4607L15.3521 13.9871C15.3521 13.9871 14.8529 14.3519 15.2177 14.5919C15.5825 14.8319 16.5905 15.4655 16.5905 15.4655L8.60329 20.0735L8.53609 18.4415C8.53609 18.4415 8.41129 17.9039 7.93129 18.1823C7.45129 18.4607 5.37769 19.6223 5.37769 19.6223L5.38729 22.6655C5.38729 23.0207 6.33769 23.9423 7.34569 23.9807C8.34409 24.0191 8.60329 23.8751 8.93929 23.7503L19.8161 17.3759L19.8065 17.3855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8064 10.5504L20.6608 9.5424V7.5168L19.816 6.5376L8.50724 0L6.77924 0.0384C6.77924 0.0384 5.32004 0.3456 5.32964 1.4976L5.35844 4.2912L7.89284 5.76C7.89284 5.76 8.50724 6.0576 8.48804 5.4048C8.45924 4.7616 8.53604 3.8112 8.53604 3.8112L16.6192 8.4768L8.60324 13.104V10.8768L9.62084 11.3664C9.62084 11.3664 9.95684 11.5488 10.1008 11.4624C10.2448 11.376 12.5392 10.0512 12.5392 10.0512C12.5392 10.0512 12.8272 9.8304 12.7984 9.648C12.7792 9.4656 12.6352 9.3024 12.6352 9.3024L5.85764 5.3856C5.85764 5.3856 5.61764 5.2416 5.43524 5.3472C5.26244 5.4528 5.37764 18.8928 5.37764 18.8928L19.8064 10.5504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4390_1048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitgert);
export default __webpack_public_path__ + "static/media/bitgert.4d95d56d487cd40ede5575fbfa14bece.svg";
export { ForwardRef as ReactComponent };